import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import { t } from "../locale";
import { button, div } from "../van/van-tags";
import type { ViewComponent } from "../van/view-component";

export class LoadingScreen implements ViewComponent {
	/**
	 * @template T
	 * @param {Promise<T>} p
	 * @returns {Promise<T>}
	 */
	async waitFor<T>(p: Promise<T>): Promise<T> {
		this.#reactive.count++;
		return p.finally(() => {
			this.#reactive.count--;
		});
	}

	#reactive = reactive({
		count: 0,
	});

	ChildDom: ChildDom;

	constructor() {
		this.ChildDom = div(
			{
				class: () =>
					this.#reactive.count > 0 ? "modal is-active" : "modal",
			},
			div({ class: "modal-background" }),
			div(
				{ class: "modal-content" },
				div(
					{ class: "box" },
					div(
						{ class: "level" },
						div(
							{ class: "level-item" },
							button({
								class: "button is-white is-large is-loading",
								disabled: true,
							}),
							button(
								{
									class: "button is-danger",
									onclick: () => {
										this.#reactive.count = 0;
										window.history.back();
									},
								},
								t("loadingScreen.abortButton"),
							),
						),
					),
				),
			),
		);
	}
}
